import {Component, ViewChild, computed, input, output} from '@angular/core';
import {Observable} from 'rxjs';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {AppMatAutocompleteComponent, XmedicalUiModule} from '@xmedical/ui';
import {TariffCode, PipesModule} from '@xmedical/core';

export interface ProcedureDisplayItem {
  id?: number;
  code: string;
  description?: string;
  rate?: number;
}

export interface ProcedureAddedEvent {
  item: TariffCode;
}

export interface ProcedureRemovedEvent {
  item: ProcedureDisplayItem;
  index: number;
}

@Component({
  selector: 'xm-procedure-widget-view',
  templateUrl: './procedure-widget-view.component.html',
  styleUrls: ['./procedure-widget-view.component.scss'],
  imports: [
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    XmedicalUiModule,
    PipesModule
  ]
})
export class ProcedureWidgetViewComponent {
  @ViewChild(AppMatAutocompleteComponent) autocomplete!: AppMatAutocompleteComponent;

  // Inputs
  items = input<ProcedureDisplayItem[]>([]);
  title = input<string>('Procedure Codes');
  searchFn = input.required<(query: string) => Observable<TariffCode[]>>();
  isProcessing = input<boolean>(false);
  canAdd = input<boolean>(true);
  canDelete = input<boolean>(true);
  usePrimaryText = input<boolean>(false);

  // Outputs
  itemAdded = output<ProcedureAddedEvent>();
  itemRemoved = output<ProcedureRemovedEvent>();

  // Computed signal for reactive hasItems check
  hasItems = computed(() => this.items().length > 0);

  onItemSelected(result: TariffCode): void {
    this.itemAdded.emit({item: result});
    this.clearSearch();
  }

  onRemoveItem(item: ProcedureDisplayItem, index: number): void {
    this.itemRemoved.emit({item, index});
  }

  private clearSearch(): void {
    if (this.autocomplete) {
      this.autocomplete.cancelSearch();
    }
  }
}
